import { render, staticRenderFns } from "./ImageInput.vue?vue&type=template&id=33c24905&scoped=true&"
import script from "./ImageInput.vue?vue&type=script&lang=js&"
export * from "./ImageInput.vue?vue&type=script&lang=js&"
import style0 from "./ImageInput.vue?vue&type=style&index=0&id=33c24905&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c24905",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
